import { MapContainer, TileLayer, Marker, useMap } from "react-leaflet";
import "leaflet/dist/leaflet.css";
import L from "leaflet";
import { useMediaQuery, useTheme } from "@mui/material";

// Ícono para los marcadores
const icon = new L.Icon({
  iconUrl: "https://cdn-icons-png.flaticon.com/512/684/684908.png",
  iconSize: [32, 32],
  iconAnchor: [16, 32],
});

// 🔹 Componente que ajusta el mapa al contenido
function AjustarMapa({ sucursales }) {
  const map = useMap();

  if (sucursales.length > 0) {
    const bounds = sucursales.map(s => [s.latitud, s.longitud]);
    map.fitBounds(bounds, { padding: [50, 50] });
  }

  return null;
}

const MapaSucursales = ({ sucursales }) => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));

  // ✅ Filtrado centralizado
  const sucursalesValidas = sucursales.filter(
    s =>
      s.latitud &&
      s.longitud &&
      !isNaN(s.latitud) &&
      !isNaN(s.longitud)
  );

  // 🔹 Si no hay sucursales con coordenadas
  if (!sucursalesValidas.length) {
    return (
      <p style={{ textAlign: "center" }}>
        No hay sucursales con ubicación disponible
      </p>
    );
  }

  return (
    <MapContainer
      center={[-26.82, -65.215]}
      zoom={13}
      style={{
        height: isMobile ? "300px" : "500px",
        width: "100%",
        zIndex: 0,
        padding: isMobile ? "10%" : "0",
      }}
      scrollWheelZoom={!isMobile}
      dragging={!isMobile}
      touchZoom={!isMobile}
      doubleClickZoom={!isMobile}
      zoomControl={!isMobile}
    >
      {/* 🔹 Ajusta SOLO si hay sucursales válidas */}
      <AjustarMapa sucursales={sucursalesValidas} />

      <TileLayer
        url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
      />

      {/* 🔹 Renderiza SOLO sucursales válidas */}
      {sucursalesValidas.map((sucursal, index) => (
        <Marker
          key={index}
          position={[sucursal.latitud, sucursal.longitud]}
          icon={icon}
        />
      ))}
    </MapContainer>
  );
};

export default MapaSucursales;
